import { Component } from "@angular/core";
import { Router, ActivatedRoute, Params } from "@angular/router";
import { FormGroup, FormArray, FormBuilder, Validators } from "@angular/forms";
import { ToastrService } from "ngx-toastr";

import {
  requiredTrim,
  matchingPasswords
} from "../../core/validators/validators";

import { AppConfig } from "../../core/config/app.config";
import { Utills } from "../../core/utility/utills";
import { UserService } from "../../core/services/user.services";
import {
  NavigationStart,
  NavigationCancel,
  NavigationEnd
} from "@angular/router";
@Component({
  selector: "app-verfifyAccount",
  preserveWhitespaces: false,
  templateUrl: "./view/verifyAccount.component.html",
  providers: [UserService]
})
export class VerifyAccountComponent {
  public verifyStatus: number = 0;
  public verifyAccount: FormGroup;
  public httpCall: any = false;
  loading: any;

  constructor(
    private toaster: ToastrService,
    private user: UserService,
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private formBuilder: FormBuilder,
    private utills: Utills,
    private config: AppConfig
  ) {
    this.loading = true;
    this.verifyAccount = formBuilder.group(
      {
        password: ["", [requiredTrim]],
        conf_password: ["", [requiredTrim]],
        email: [""]
      },
      { validator: matchingPasswords("password", "conf_password") }
    );
  }

  public ngOnInit() {
    this.verifyStatus = 1;

    this.activatedRoute.params.subscribe((param: any) => {
      this.user
        .verifyGeneratePwdToken({ verificationToken: param["id"] })
        .subscribe((res: any) => {
          //console.log("res ",res);
          if (res.code == this.config.statusCode.success) {
            //console.log("res ",res);
            let email = res.data.user.email;
            this.verifyAccount.controls["email"].patchValue(email);
            this.verifyStatus = 3;
          } else {
            this.verifyStatus = 2;
          }
        });
    });
  }

  changePassword() {
    this.httpCall = true;
    this.activatedRoute.params.subscribe((param: any) => {
      let data = this.verifyAccount.value;
      data.verificationToken = param["id"];
      this.user.createFirstPassword(data).subscribe((res: any) => {
        this.httpCall = false;
        //console.log("res ",res);
        if (res.code == this.config.statusCode.success) {
          this.verifyStatus = 4;
          this.toaster.success(res.message);
          this.router.navigate([""]);
        } else {
          this.toaster.error(res.message);
        }
      });
    });
  }

  ngAfterViewInit() {
    this.router.events.subscribe(event => {
      if (event instanceof NavigationStart) {
        this.loading = true;
      } else if (
        event instanceof NavigationEnd ||
        event instanceof NavigationCancel
      ) {
        this.loading = false;
      }
    });
  }
}
